export default function WhyToolnova() {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: 'Save Time',
      description: 'Quickly discover AI tools without spending hours researching across the web.',
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Organized Categories',
      description: 'Browse tools by category to find exactly what you need for your workflow.',
    },
    {
      icon: 'ri-star-line',
      title: 'Curated Recommendations',
      description: 'Explore handpicked AI tools trusted by creators and businesses worldwide.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Boost Productivity',
      description: 'Find powerful AI tools that help you work smarter and achieve more.',
    },
  ];

  return (
    <section className="py-32 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a] relative">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gray-700/60 to-transparent"></div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_50%,rgba(20,184,166,0.03),transparent)]"></div>
      <div className="max-w-7xl mx-auto relative z-10">

        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-teal-500/10 border border-teal-500/20 text-teal-400 text-xs font-semibold tracking-widest uppercase mb-5">
            Why Choose Us
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5 tracking-tight leading-tight">
            Why Use Toolnova
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Toolnova helps you save time by organizing AI tools into clear categories so you can quickly discover tools that improve productivity and workflows.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="group relative p-8 bg-gray-900/60 border border-gray-800/80 rounded-2xl hover:border-teal-500/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(20,184,166,0.15)] hover:-translate-y-1"
            >
              <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-teal-500/0 group-hover:via-teal-500/50 to-transparent transition-all duration-300"></div>
              <div className="w-14 h-14 flex items-center justify-center bg-teal-500/10 rounded-xl mb-5 group-hover:bg-teal-500/20 transition-colors duration-300">
                <i className={`${benefit.icon} text-2xl text-teal-400`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-3 tracking-tight">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-gray-700/60 to-transparent"></div>
    </section>
  );
}